import { render, staticRenderFns } from "./AudienceOverview.vue?vue&type=template&id=68f88ee5&lang=pug&"
import script from "./AudienceOverview.vue?vue&type=script&lang=js&"
export * from "./AudienceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports